import BaseModal from 'components/atoms/base-modal';
import ClinicFilterSelectBoxV2 from 'components/molecules/include-clinic-select-box';
import { useGetPotentialPatientsCount } from 'infrastructure/hooks/patient/use-get-potential-transfer-count';
import { useEffect, type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { SelectAdditionalFields } from './additional-fields-select';
import { useFilter } from './filter/use-filter';
import { SelectLanguage } from './language-select';
import { PatientsToTransfer } from './patients-to-transfer-input';
import { SelectPrograms } from './programs-select';
import s from './styles.module.scss';
import { SubmitAction } from './submit-action-button';
import TransferFrom from './transfer-from-input';
import TransferTo from './transfer-to-input';
import { PotentialPatientsCount } from './transferable-patients';

type Props = {
  open: boolean;
  onCancel: () => void;
};

const BulkTransferPatientsModal: FC<Props> = (props) => {
  const { open, onCancel } = props;
  const { t } = useTranslation();
  const { filter, updateFilter, clearModalFilter } = useFilter();
  const { data, isLoading } = useGetPotentialPatientsCount(filter);

  useEffect(() => {
    clearModalFilter();
  }, [open]);

  return (
    <BaseModal
      title={t('labels.bulkTransferPatients')}
      open={open}
      onCancel={onCancel}
    >
      <div className={s['modal-body']}>
        <TransferFrom />
        <TransferTo />
        <ClinicFilterSelectBoxV2
          useAdminApi
          showOnInteractiveTimeDashboard={false}
          included={filter?.clinicGuid}
          parentClinicGuid={filter?.parentClinicGuid}
          onChange={({ included = [], parentClinicGuid = [] }) => {
            updateFilter({
              clinicGuid: included,
              parentClinicGuid,
            });
          }}
        />
        <SelectLanguage />
        <SelectPrograms />
        <hr />
        <SelectAdditionalFields />
        <hr />
        <PotentialPatientsCount
          count={data?.potentialPatientsCount}
          isLoading={isLoading}
        />
        <PatientsToTransfer
          potentialPatientsCount={data?.potentialPatientsCount}
        />
        <SubmitAction
          onCancel={onCancel}
          potentialPatientsCount={data?.potentialPatientsCount}
        />
      </div>
    </BaseModal>
  );
};

export default BulkTransferPatientsModal;
